import {
  ICreateCompanyReq,
  ICompany,
  IUpdateGoogleAds
} from "./../../models/company/index";
import {
  IBasePagingRes,
  IBaseResponseModel
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { IGetUsersReq } from "../../models/user";

const API = ApiEndpoints.COMPANY;
const baseURL = envConfig.ACCOUNT_ENDPOINT;

const getPage = (data: IGetUsersReq): Promise<IBasePagingRes<any>> => {
  return api.get(baseURL, API.GET_PAGE_COMPANY.url, {
    params: data
  });
};

const create = (
  data: ICreateCompanyReq
): Promise<IBaseResponseModel<IBasePagingRes<any>>> => {
  return api.post(baseURL, API.CREATE.url, data);
};

const getSingle = (id: string): Promise<IBaseResponseModel<ICompany>> => {
  return api.get(baseURL, `${API.GET_SIGNLE.url}/${id}`);
};

const update = (data: ICompany): Promise<IBaseResponseModel<any>> => {
  return api.put(baseURL, API.UPDATE.url, data);
};

const deleteGroup = (id: string): Promise<IBaseResponseModel<ICompany>> => {
  return api.delete(baseURL, `${API.DELETE.url}/${id}`);
};

const getGoogleAds = (): Promise<IBaseResponseModel<any>> => {
  return api.get(baseURL, `${API.GET_GOOGLEADS.url}`);
};

const updateGoogleAds = (
  data: IUpdateGoogleAds
): Promise<IBaseResponseModel<any>> => {
  return api.put(baseURL, API.UPDATE_GOOGLEADS.url, data);
};

const CompanyService = {
  getPage,
  create,
  getSingle,
  update,
  deleteGroup,
  getGoogleAds,
  updateGoogleAds
};

export default CompanyService;
